(() => {
  if (window.AirwinksCartLoader) return;
  window.AirwinksCartLoader = true;

  const currentSrc = document.currentScript?.src || '';
  const currentUrl = currentSrc ? new URL(currentSrc, window.location.origin) : null;
  const base = currentUrl ? currentUrl.href.slice(0, currentUrl.href.lastIndexOf('/') + 1) : '';
  const version = currentUrl?.searchParams.get('v') || String(Date.now());

  const load = (name) => new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = `${base}${name}?v=${encodeURIComponent(version)}`;
    script.async = false;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });

  load('airwinks-cart-ui.js')
    .then(() => load('airwinks-cart-lines.js'))
    .then(() => load('airwinks-cart-product.js'))
    .catch(() => {
      window.AirwinksCartLoader = false;
    });
})();
